import 'antd/dist/antd.css';
import './App.css';
import routeAllScreens from './screens/routes';

function App() {
  return routeAllScreens();
}

export default App;
